import React from 'react';
import { Box, Grid, Paper } from '@mui/material';
import ShimmerBox from './ShimmerBox';
import TableShimmer from './TableShimmer';

const WIDGET_HEIGHT = 380;

const widgetPaperSx = {
  p: 1.5,
  borderRadius: 2,
  boxShadow: '0 1px 6px rgba(15, 23, 42, 0.06)',
  height: WIDGET_HEIGHT,
  minHeight: WIDGET_HEIGHT,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  bgcolor: 'var(--bg-primary)',
  border: '1px solid var(--border-light)',
};

const MetricCardShimmer: React.FC<{ wide?: boolean }> = ({ wide = false }) => (
  <Paper
    elevation={0}
    sx={{
      p: 2,
      borderRadius: 2,
      height: 96,
      minHeight: 96,
      background: 'var(--bg-primary)',
      border: '1px solid var(--border-light)',
      boxShadow: '0 1px 6px rgba(15, 23, 42, 0.06)',
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, height: '100%' }}>
      <ShimmerBox className="h-10 w-10 shrink-0 rounded-xl" />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <ShimmerBox className="mb-2 h-3 rounded" style={{ width: wide ? '45%' : '60%' }} />
        <ShimmerBox className="h-7 rounded-md" style={{ width: wide ? '70%' : '40%' }} />
      </Box>
    </Box>
  </Paper>
);

const ChartWidgetShimmer: React.FC = () => (
  <Paper elevation={0} sx={widgetPaperSx} data-testid="dashboard-chart-shimmer">
    <ShimmerBox className="mb-3 h-4 w-40 rounded" />
    <Box sx={{ flex: 1, display: 'flex', alignItems: 'flex-end', gap: 1.5, px: 1, pb: 1 }}>
      {[72, 48, 88, 56, 96, 40, 64].map((height, index) => (
        <ShimmerBox
          key={`bar-${index}`}
          className="flex-1 rounded-t-md"
          style={{ height: `${height}%`, minHeight: 24 }}
        />
      ))}
    </Box>
  </Paper>
);

const TableWidgetShimmer: React.FC = () => (
  <Paper elevation={0} sx={widgetPaperSx} data-testid="dashboard-table-shimmer">
    <ShimmerBox className="mb-3 h-4 w-36 rounded" />
    <Box sx={{ flex: 1, minHeight: 0 }}>
      <TableShimmer columns={2} rows={7} minHeight={300} className="shadow-none" />
    </Box>
  </Paper>
);

const DashboardShimmer: React.FC = () => (
  <Grid container spacing={1.25} data-testid="dashboard-shimmer">
    <Grid item xs={12} md={3}>
      <MetricCardShimmer />
    </Grid>
    <Grid item xs={12} md={3}>
      <MetricCardShimmer />
    </Grid>
    <Grid item xs={12} md={6}>
      <MetricCardShimmer wide />
    </Grid>

    <Grid item xs={12} lg={7}>
      <ChartWidgetShimmer />
    </Grid>
    <Grid item xs={12} lg={5}>
      <TableWidgetShimmer />
    </Grid>

    <Grid item xs={12} lg={7}>
      <ChartWidgetShimmer />
    </Grid>
    <Grid item xs={12} lg={5}>
      <TableWidgetShimmer />
    </Grid>

    <Grid item xs={12} lg={4}>
      <TableWidgetShimmer />
    </Grid>
    <Grid item xs={12} lg={4}>
      <TableWidgetShimmer />
    </Grid>
    <Grid item xs={12} lg={4}>
      <ChartWidgetShimmer />
    </Grid>
  </Grid>
);

export default DashboardShimmer;
